export const validationMessages = {
  required: (fieldName: string) =>
    `${
      fieldName?.charAt(0).toUpperCase() + fieldName?.slice(1).toLowerCase()
    } is required.`,
  format: (fieldName: any) => ` ${fieldName} should be in correct format.`,
  atLeastOneSelected: (fieldName: any) =>
    `At least one ${fieldName} must be selected.`,
  passwordLength: (fieldName: any, minLength: any) =>
    `${fieldName} should be at least ${minLength} characters.`,
  contactLength: (fieldName: string, minLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be ${minLength} digit.`,
  passwordComplexity: (fieldName: any) =>
    `${fieldName} should be an uppercase lowercase number and special characters.`,
  passwordsMatch: (fieldName: any, confirmFieldName: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } and ${confirmFieldName.toLowerCase()} should be same.`,
  phoneNumber: (fieldName: string) =>
    `Invalid ${fieldName.toLowerCase()} format.`,
  notSameAsField: (fieldName: any, comparedField: any) =>
    `${fieldName} should be different from ${comparedField}.`,
  maxChar: (fieldName: any, maxLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be ${maxLength} Characters.`,
  maxLength: (fieldName: any, maxLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be maximum ${maxLength} digits.`,
  minLength: (fieldName: any, minLength: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be minimum ${minLength} digits.`,
  positiveNumber: (fieldName: any) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be positive`,
  url: (field: any) => `${field} should be a valid URL`,
  greaterThan: (fieldName: any, comparedField: any) =>
    `${comparedField} should be greater than or equal to ${fieldName}.`,
  greaterTime: (fieldName: any, comparedField: any) =>
    `${comparedField} should be greater than ${fieldName}.`,
  otpFormat: (fieldName: any) => `${fieldName} should be in number digit.`,
};

export const fileLimitErrorMessage = "File Size is too Large! (more than 1 MB).";
export const fileTypePDFErrorMessage = "Only PDF is allowed.";

export const InputPlaceHolder = (fieldName: string) => {
  return `Enter ${fieldName?.toLowerCase()}`;
};

export const SelectPlaceHolder = (fieldName: string) => {
  return `Select ${fieldName?.toLowerCase()}`;
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;